import type { SVGAttributes } from 'react';

export function ShareInstagramIcon(props: SVGAttributes<SVGSVGElement>) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" {...props} viewBox="0 0 24 24">
			<rect width="24" height="24" fill="#fff" rx="4" />
			<path
				fill="currentColor"
				d="M12 6c2.397 0 3.595 0 4.458.571.386.255.716.586.97.971C18 8.405 18 9.603 18 12s0 3.595-.571 4.458a3.4 3.4 0 0 1-.971.97C15.595 18 14.397 18 12 18s-3.595 0-4.458-.571a3.4 3.4 0 0 1-.97-.971C6 15.595 6 14.397 6 12s0-3.595.571-4.458a3.4 3.4 0 0 1 .971-.97C8.405 6 9.603 6 12 6m0 2.894a3.107 3.107 0 1 0 0 6.213 3.107 3.107 0 0 0 0-6.213m0 1.05a2.056 2.056 0 1 1-.001 4.113A2.056 2.056 0 0 1 12 9.944m3.229-1.936a.73.73 0 1 0 .001 1.46.73.73 0 0 0-.002-1.46"
			/>
		</svg>
	);
}
